import { http, isHttpError, rawHttp } from '../http';
import { UploadedDocumentData } from './upload-document';

export async function signingRequestDocumentUpload(
	requesterCognitoId: string,
	documentUlid: string,
	document: File,
): Promise<UploadedDocumentData> {
	const uploadDocumentUrl = await http.post<{
		url: string;
		fields: Record<
			| 'key'
			| 'x-amz-algorithm'
			| 'x-amz-credential'
			| 'x-amz-date'
			| 'x-amz-security-token'
			| 'policy'
			| 'x-amz-signature',
			string
		>;
		doc_ulid: string;
		doc_path: string;
	}>('documents/signing-request-upload', {
		file_tier: 'tier-3',
		file_name: document.name,
		requester_cognito_user_id: requesterCognitoId,
		doc_ulid: documentUlid,
	});

	if (isHttpError(uploadDocumentUrl)) {
		throw new Error('getUploadUrl failed');
	} else {
		const formData = new FormData();
		formData.append('key', uploadDocumentUrl.fields.key);
		formData.append(
			'x-amz-algorithm',
			uploadDocumentUrl.fields['x-amz-algorithm'],
		);
		formData.append(
			'x-amz-credential',
			uploadDocumentUrl.fields['x-amz-credential'],
		);
		formData.append('x-amz-date', uploadDocumentUrl.fields['x-amz-date']);
		formData.append(
			'x-amz-security-token',
			uploadDocumentUrl.fields['x-amz-security-token'],
		);
		formData.append('policy', uploadDocumentUrl.fields.policy);
		formData.append(
			'x-amz-signature',
			uploadDocumentUrl.fields['x-amz-signature'],
		);
		formData.append('file', document, document.name);

		await rawHttp.post(uploadDocumentUrl.url, formData);

		return {
			docUlid: uploadDocumentUrl.doc_ulid,
			docPath: uploadDocumentUrl.doc_path,
			// The signing-request flow is multi-signer, so it never offers the
			// lineage page and never offers public retrieval either.
			publicRetrievalAllowed: false,
		};
	}
}
